"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("stremio/core");
var getLoadingProgress = function (infoHash, statistics) {
    var _a;
    if (infoHash === null) {
        return 100;
    }
    if (statistics === null) {
        return 0;
    }
    var MB = 1024 * 1024;
    var peerScore = Math.min(1, statistics.peers / 8) * 20;
    var minDownload = Math.min(8 * MB, Math.max(2 * MB, ((_a = statistics.streamLen) !== null && _a !== void 0 ? _a : 0) * 0.008));
    var downloadedScore = Math.min(1, statistics.downloaded / minDownload) * 70;
    var speedScore = Math.min(1, statistics.downloadSpeed / MB) * 10;
    return Math.min(99, peerScore + downloadedScore + speedScore);
};
var useStatistics = function (player, streamingServer) {
    var _a, _b, _c, _d, _e;
    var core = (0, core_1.useCore)();
    var stream = ((_a = player.stream) === null || _a === void 0 ? void 0 : _a.type) === 'Ready' ? player.stream.content : null;
    var infoHash = (_b = stream === null || stream === void 0 ? void 0 : stream.infoHash) !== null && _b !== void 0 ? _b : null;
    var fileIdx = (_c = stream === null || stream === void 0 ? void 0 : stream.fileIdx) !== null && _c !== void 0 ? _c : null;
    var statisticsValue = ((_d = streamingServer.statistics) === null || _d === void 0 ? void 0 : _d.type) === 'Ready' ? streamingServer.statistics.content : null;
    var statistics = infoHash !== null && (statisticsValue === null || statisticsValue === void 0 ? void 0 : statisticsValue.infoHash.toLowerCase()) === infoHash.toLowerCase() ? statisticsValue : null;
    (0, react_1.useEffect)(function () {
        if (infoHash === null) {
            return undefined;
        }
        var requestStatistics = function () {
            void core.transport.dispatch({
                action: 'StreamingServer',
                args: {
                    action: 'GetStatistics',
                    args: {
                        infoHash: infoHash,
                        fileIdx: fileIdx,
                    },
                },
            });
        };
        requestStatistics();
        var interval = window.setInterval(requestStatistics, 5000);
        return function () { return window.clearInterval(interval); };
    }, [core.transport, fileIdx, infoHash]);
    return {
        infoHash: infoHash,
        peers: (_e = statistics === null || statistics === void 0 ? void 0 : statistics.peers) !== null && _e !== void 0 ? _e : 0,
        speed: statistics ? Number((statistics.downloadSpeed / 1000 / 1000).toFixed(2)) : 0,
        completed: typeof (statistics === null || statistics === void 0 ? void 0 : statistics.streamProgress) === 'number' ? Number((statistics.streamProgress * 100).toFixed(2)) : null,
        progress: getLoadingProgress(infoHash, statistics),
    };
};
exports.default = useStatistics;
